var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamiliar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44737 11.9899V13.8809C8.63756 13.5913 7.77088 13.5025 6.9201 13.6219C6.06932 13.7413 5.25928 14.0653 4.55802 14.5669C3.85675 15.0684 3.28473 15.7327 2.88999 16.5041C2.49525 17.2755 2.28931 18.1314 2.28947 19H0.500001C0.499586 17.8951 0.749325 16.8048 1.23008 15.8126C1.71083 14.8204 2.40984 13.9527 3.27352 13.2759C4.13721 12.5991 5.14266 12.1313 6.21281 11.9082C7.28296 11.6851 8.38941 11.7137 9.44737 11.9899ZM7.6579 10.8571C4.69184 10.8571 2.28947 8.42786 2.28947 5.42857C2.28947 2.42929 4.69184 0 7.6579 0C10.6239 0 13.0263 2.42929 13.0263 5.42857C13.0263 8.42786 10.6239 10.8571 7.6579 10.8571ZM7.6579 9.04762C9.63526 9.04762 11.2368 7.4281 11.2368 5.42857C11.2368 3.42905 9.63526 1.80952 7.6579 1.80952C5.68053 1.80952 4.07895 3.42905 4.07895 5.42857C4.07895 7.4281 5.68053 9.04762 7.6579 9.04762ZM13.0263 14.4762V11.7619H14.8158V14.4762H17.5V16.2857H14.8158V19H13.0263V16.2857H10.3421V14.4762H13.0263Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliar);
export default __webpack_public_path__ + "static/media/familiar.ad779be897f5d0c6baf6831a3e148632.svg";
export { ForwardRef as ReactComponent };